import React, { useState, useEffect, useRef, startTransition } from "react";
import styles from "./videoProductItem.module.scss"; // 假设样式文件名为 index.module.scss
import { FmIcon, FmImage } from "@/ui-component";

interface VideoProductItemProps {
    products_video_list: any[];
    rowID: number;
    imgShow?: string;
}

function VideoProductItem({
    products_video_list,
    rowID,
    imgShow,
}: VideoProductItemProps) {
    const [videoLoaded, setVideoLoaded] = useState(true);
    const [muted, setMuted] = useState(true);
    const [isAnimating, setIsAnimating] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    const observer = useRef<IntersectionObserver | null>(null);
    const progressTimer = useRef<NodeJS.Timeout | undefined>(undefined);

    useEffect(() => {
        observer.current = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const videoElement = entry.target as HTMLVideoElement;

                if (entry.isIntersecting) {
                    setIsAnimating(false);
                    videoRef.current?.play().catch(e => {
                        console.error("播放失败:", e);
                        // 失败后尝试静音播放
                        setMuted(true);
                        videoRef.current?.play();
                    });
                } else {
                    videoElement.pause();
                    setVideoLoaded(true);
                    setIsAnimating(true);
                    clearInterval(progressTimer.current);
                }
            });
        }, { threshold: 0.4 });

        if (videoRef.current) {
            observer.current.observe(videoRef.current);
        }

        return () => {
            if (observer.current && videoRef.current) {
                observer.current.unobserve(videoRef.current);
            }
        };
    }, []);

    const handlePlayPause = () => {
        if (videoLoaded) {
            startTransition(() => {
                setVideoLoaded(false);
                setIsAnimating(false);
                setMuted(false);
            });
            videoRef.current?.play();
            progressTimer.current = setInterval(changeProgress, 60);
        } else {
            setVideoLoaded(true);
            setIsAnimating(true);
            setMuted(true);
            videoRef.current?.pause();
            clearInterval(progressTimer.current);
        }
    };

    const changeProgress = () => {
        const progress = document.querySelector(
            `.${styles.progress}${rowID}`,
        ) as HTMLElement;

        const percent =
            (videoRef.current?.currentTime &&
                videoRef.current?.currentTime / videoRef.current?.duration) ||
            0;
        if (progress) {
            progress.style.width = percent === 1 ? "0%" : `${percent * 100}%`;
        }

    };

    // const toggleMuted = () => {
    //     setMuted(!muted);
    // };

    return (
        <div className={styles.Bcontainer}>
            <div
                style={{ position: "relative", width: "100%", height: "100%" }}
                className={styles.videoVal}
                onClick={handlePlayPause}
            >
                <video
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                    muted={muted}
                    autoPlay
                    loop
                    x5-video-player-type="h5"
                    preload="auto"
                    playsInline
                    webkit-playsinline="true"
                    ref={videoRef}
                //去除默认图片  
                // poster={
                //     products_video_list[0]?.complete_cover_url ||
                //     imgShow ||
                //     "https://s3-us-west-1.amazonaws.com/imgtest.firmoo.com/images/2023/1228/98db50584271daaf97ef4571da81eb3b.jpg"
                // }
                >
                    <source
                        src={products_video_list[0]?.complete_video_url}
                        type="video/mp4"
                    />
                    Your browser doesn&apos;t support HTML5 video
                </video>
                <div
                    className={`${styles.videoPlay} ${!isAnimating ? styles.active : ""}`}
                >
                    <FmIcon
                        icon={"icon--video"}
                        style={{ fontSize: "0.5rem", color: "white" }}
                    ></FmIcon>
                </div>
                {/* <div className={styles.progressBox}>
                    <div
                        className={`${styles.progress} ${styles.progress}${rowID}`}
                    ></div>
                </div> */}
                {/* <div className={styles.monutBox} onClick={toggleMuted}>
                    <FmImage
                        className={styles.imgs}
                        image={
                            muted
                                ? "https://df5apg8r0m634.cloudfront.net/images/2024/0808/e32b5e8a96c6704a6cb8ed84c4ccb7e6.webp"
                                : "https://df5apg8r0m634.cloudfront.net/images/2024/0808/2c50c264633f3114744120b5298d2e33.webp"
                        }
                    />
                </div> */}
            </div>
        </div>
    );
}

export default VideoProductItem;
